import { gql, graphQueryBang } from "shared/lib/graphql"

const QueryFieldFragment = `
  id
  slug
  label
  helper_text
  required
  weight
  normalized_field_type
  field_type_definition_slug
  static_options {
    label
    value
  }
`

const replaceFragments = query => query.replace(/QUERY_FIELD_FRAGMENT/g, QueryFieldFragment)

const QueryFieldsQuery = replaceFragments(gql`
  query QueryFieldsQuery($query_id: String!) {
    query(module_name: $query_id) {
      query_fields {
        QUERY_FIELD_FRAGMENT
      }
    }
  }
`)

const QueryFieldAddMutation = replaceFragments(gql`
  mutation QueryFieldAddMutation(
    $query_id: ID!
    $slug: String!
    $label: String!
    $helper_text: String
    $required: Boolean!
    $field_type_slug: String!
    $static_options: [FieldOptionInput]
  ) {
    queryFieldCreate(
      input: {
        query_id: $query_id
        name: $slug
        label: $label
        helper_text: $helper_text
        required: $required
        field_type_slug: $field_type_slug
        static_options: $static_options
      }
    ) {
      query_field {
        QUERY_FIELD_FRAGMENT
      }
      errors {
        attribute
        message
      }
    }
  }
`)

const QueryFieldUpdateMutation = replaceFragments(gql`
  mutation QueryFieldUpdateMutation(
    $id: ID!
    $slug: String
    $label: String
    $helper_text: String
    $required: Boolean
    $field_type_slug: String
    $weight: Int
    $static_options: [FieldOptionInput]
  ) {
    queryFieldUpdate(
      input: {
        id: $id
        name: $slug
        label: $label
        helper_text: $helper_text
        required: $required
        field_type_slug: $field_type_slug
        weight: $weight
        static_options: $static_options
      }
    ) {
      query_field {
        QUERY_FIELD_FRAGMENT
      }
      errors {
        attribute
        message
      }
    }
  }
`)

const StepFieldReorderMutation = gql`
  mutation StepFieldReorderMutation(
    $channel_module_name: String!
    $step_module_name: String!
    $step_type: String!
    $field_ids: [ID!]!
  ) {
    reorderStepFields(
      input: {
        channel_module_name: $channel_module_name
        step_module_name: $step_module_name
        step_type: $step_type
        field_ids: $field_ids
      }
    ) {
      errors {
        attribute
      }
    }
  }
`

const QueryFieldDeleteMutation = gql`
  mutation QueryFieldDeleteMutation($id: ID!) {
    queryFieldDelete(input: { id: $id }) {
      errors {
        attribute
        message
      }
    }
  }
`

export function getQueryFields(query) {
  return graphQueryBang(QueryFieldsQuery, {
    query_id: query.id,
  }).then(data => data.query.query_fields)
}

export function queryFieldAdd(query_id, queryField) {
  return graphQueryBang(QueryFieldAddMutation, {
    query_id,
    slug: queryField.slug,
    label: queryField.label,
    helper_text: queryField.helperText,
    required: queryField.required === "true" ? true : false,
    field_type_slug: queryField.fieldTypeSlug,
    static_options: queryField.populator,
  }).then(data => data.queryFieldCreate)
}

export function queryFieldUpdate(queryField) {
  return graphQueryBang(QueryFieldUpdateMutation, {
    id: queryField.id,
    slug: queryField.slug,
    label: queryField.label,
    helper_text: queryField.helper_text || queryField.helperText,
    required: queryField.required === "true" ? true : false,
    field_type_slug: queryField.fieldTypeSlug || queryField.field_type_definition_slug,
    weight: queryField.weight,
    static_options: queryField.populator,
  }).then(data => data.queryFieldUpdate)
}

export function queryFieldDelete(queryField) {
  return graphQueryBang(QueryFieldDeleteMutation, {
    id: queryField.id,
  }).then(data => data.queryFieldDelete)
}

export function queryFieldsReorder(service, query, fieldIds) {
  return graphQueryBang(StepFieldReorderMutation, {
    channel_module_name: service.slug,
    step_module_name: query.module_name,
    step_type: "query",
    field_ids: fieldIds,
  }).then(response => {
    if (response.reorderStepFields?.errors.length > 0) {
      console.error(response.errors)
    }
  })
}
